import usersService from '../services/users'
import { SET_USER, CLEAR_USER, UPDATE_USER } from '../actions/auth'
import { notification } from 'antd'

import { message } from 'antd'
import subscribeUser from './../subscription'
import { GET_ALL } from '../actions/notification'

// manpulates the data coming from backend
const adapterFunc = (user) => {
  return { ...user.user, token: user.token }
}

let user = window.localStorage.getItem('spanidea-user')
const intialState = user
  ? { user: adapterFunc(JSON.parse(user)), isAuth: true }
  : { user: null, isAuth: false }

const authReducer = (state = intialState, action) => {
  switch (action.type) {
    case SET_USER:
      return { user: adapterFunc(action.user), isAuth: true }
    case UPDATE_USER:
      return { user: adapterFunc(action.user), isAuth: true }
    case CLEAR_USER:
      return { user: null, isAuth: false }
    default:
      return state
  }
}

export const editProfile = (user) => {
  return async (dispatch) => {
    try {
      const response = await usersService.update(user)
      if (response) {
        window.localStorage.setItem('spanidea-user', JSON.stringify(response))
        dispatch({ type: UPDATE_USER, user: response })

        notification.success({
          message: 'Profile updated successfully'
        })
      } else {
        notification.error({
          message: "Profile changes can't be saved"
        })
      }
    } catch (error) {
      console.log(error)
      if (error.response?.data?.keyPattern?.email === 1) {
        notification.error({ message: 'Email already registered' })
      } else if (error.response?.data?.keyPattern?.username === 1) {
        notification.error({ message: 'Username already registered' })
      } else {
        notification.error({ message: "Profile changes can't be saved" })
      }
    }
  }
}

export const register = (credentials) => {
  return async () => {
    try {
      const response = await usersService.register(credentials)
      if (!response) {
        throw new Error('invalid error with response')
      }
      notification.success({
        message: 'User registered successfully'
      })
      return { success: true }
    } catch (error) {
      console.log(error)
      if (error.response?.data?.keyPattern?.email === 1) {
        notification.error({
          message: 'Email already registered'
        })
      } else if (error.response?.data?.keyPattern?.username === 1) {
        notification.error({
          message: 'Username already registered'
        })
      } else {
        notification.error({
          message: "Can't register"
        })
      }
      return { success: false }
    }
  }
}

export const requestOTP = (credentials) => {
  return async (dispatch) => {
    try {
      const response = await usersService.requestOtp(credentials);
      window.localStorage.setItem(
        'spanidea-user',
        JSON.stringify({ email: credentials.email })
      )
      return { success: true, data: response }
    } catch (error) {
      console.log(error)
      notification.error({
        message: 'Invalid credentials'
      })
      return { success: false }
    }
  }
}

export const verifyOTP = (credentials) => {
  return async (dispatch) => {
    try {
      const response = await usersService.verifyOtp(credentials)
      window.localStorage.setItem('spanidea-user', JSON.stringify(response))
      subscribeUser()
      dispatch({ type: SET_USER, user: response })
      notification.success({
        message: 'User logged in successfully'
      })
    } catch (error) {
      console.log(error)
      notification.error({
        message: 'Invalid OTP'
      })
    }
  }
}

export const logout = () => {
  return async (dispatch) => {
    try {
      await usersService.logout()
      dispatch({ type: CLEAR_USER })
      window.localStorage.removeItem('spanidea-user')
      notification.success({
        message: 'User logged out successfully'
      })
    } catch (error) {
      console.log(error)
      dispatch({ type: CLEAR_USER })
      window.localStorage.removeItem('spanidea-user')
      notification.success({
        message: 'User logged out successfully'
      })
    }
  }
}

export const forgotPassword = (email) => {
  return async (dispatch) => {
    try {
      const response = await usersService.forgotPassword(email)

      if (response) {
        notification.success({
          message: response.message
        })
        dispatch({ type: CLEAR_USER })
        return { success: true }
      } else {
        notification.error({
          message: response.message
        })
        return { success: false }
      }
    } catch (error) {
      console.log(error)
      notification.error({
        message: error.response.data.message
      })
      return { success: false }
    }
  }
}

export const reset = (token) => {
  return async (dispatch) => {
    try {
      const response = await usersService.reset(token)

      if (response) {
        notification.success({
          message: response.message
        })
        dispatch({ type: CLEAR_USER })
        return { success: true }
      } else {
        message.error('Some error occured. Please try again.')
        return { success: false }
      }
    } catch (error) {
      console.log(error)
      message.error('Some error occured. Please try again.')
      return { success: false }
    }
  }
}

export const resetPassword = (token, password) => {
  return async (dispatch) => {
    try {
      const response = await usersService.resetPassword(token, password)

      if (response) {
        notification.success({
          message: response.message
        })
        dispatch({ type: CLEAR_USER })
        return { success: true }
      } else {
        message.error('Some error occured. Please try again.')
        return { success: false }
      }
    } catch (error) {
      console.log(error)
      message.error('Some error occured. Please try again.')
      return { success: false }
    }
  }
}

export default authReducer
